export default __webpack_public_path__ + "static/media/aidsMapBlack.2644be62.png";